var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 80,
    viewBox: "0 0 48 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M47.04 7.78312L39.92 0.703125L0.359985 40.3031L39.96 79.9031L47.04 72.8231L14.52 40.3031L47.04 7.78312Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftarrow);
export default __webpack_public_path__ + "static/media/leftarrow.f3f0bb2c041648c34b954a31fd36c006.svg";
export { ForwardRef as ReactComponent };